export const LOADING_DATA = 'LOADING_DATA';
export const BUILD_DATA = 'BUILD_DATA';



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/constants/index.js
 **/